import FieldbookSetup from "./FieldbookSetup";
import FieldbookPdf from "./FieldbookPdf";

const Fieldbook = {
  Setup: FieldbookSetup,
  Pdf: FieldbookPdf,
};

export default Fieldbook;
